import React from 'react';
import { Col} from 'react-bootstrap';
import * as yup from 'yup';
import SmartField from '../../../../rhf/smartfield';

export const GetHousingValidationSchema = (formValues) => {
    const base = {
        contactname: yup.string().required("Contact Name is Required"),
        contactemail: yup.string().email("Must be a valid Email.").required("Email must be provided."),
        contactphone: yup.string().required("Contact Phone must be provided."),
        propertyaddress: yup.string().required("Property Address must be provided."),
        propertycity: yup.string().required('Property City must be provided.'),
        propertystate: yup.string().required('Select a state'),
        propertyzip: yup.string().required('Property zip must be provided.')
    }

    return base;
    
}

const HousingFields = ({register,errors,lookupdata}) => {
    return(
        <>
                <Col xs={12}>
                    <strong className="d-flex justify-content-center">Housing Information</strong>
                </Col>
                <Col xs={12} md={6}>
                    <SmartField
                        label='Contact Name'
                        name='contactname'
                        type='text'
                        style={{width: '100%'}}
                        register={register}
                        errors={errors}
                    />
                </Col>
                <Col xs={12} md={6}>
                    <SmartField
                        label='Contact Email'
                        name='contactemail'
                        type='text'
                        style={{width: '100%'}}
                        register={register}
                        errors={errors}
                    />
                </Col>
                <Col xs={12} md={6} lg={4}>
                    <SmartField
                        label='Contact Phone'
                        name='contactphone'
                        type='text'
                        style={{width: '100%'}}
                        register={register}
                        errors={errors}
                    />
                </Col>
                <Col xs={12}>
                    <SmartField
                        label='Property Street Address'
                        name='propertyaddress'
                        type='text'
                        style={{width: '100%'}}
                        register={register}
                        errors={errors}
                    />
                </Col>
                <Col xs={12} md={4}>
                    <SmartField
                        label='City'
                        name='propertycity'
                        type='text'
                        style={{width: '100%'}}
                        register={register}
                        errors={errors}
                    />
                </Col>
                <Col xs={12} md={4}>
                    <SmartField
                        label='State'
                        name='propertystate'
                        type='select'
                        style={{width: '100%',height: '30px'}}
                        options={lookupdata.states}
                        register={register}
                        errors={errors}
                    />
                </Col>
                <Col xs={12} md={4}>
                    <SmartField
                        label='Zip'
                        name='propertyzip'
                        type='text'
                        style={{width: '100%'}}
                        register={register}
                        errors={errors}
                    />
                </Col>
                <Col xs={12}>
                    <SmartField
                        label='Notes'
                        name='housingnotes'
                        type='textarea'
                        style={{width: '100%'}}
                        register={register}
                        errors={errors}
                    />
                </Col>
            </>
    )
}

export default HousingFields;